import {
  CITY_SCHEMA_MESSAGES,
  FIRST_NAME_SCHEMA_MESSAGES,
  LAST_NAME_SCHEMA_MESSAGES,
  STREET_ADDRESS_SCHEMA_MESSAGES,
  ZIP_CODE_SCHEMA_MESSAGES
} from "src/constants/schemaValidation";
import { getAvailableStates } from "src/lib/getAvailableStates";
import { z } from "zod";
import translate from "src/lib/translate";

const states = getAvailableStates().map((s) => s.id) as [string, ...string[]];
const stateError = translate("state_required");

export const ShippingAddressSchema = z.object({
  firstName: z.string(FIRST_NAME_SCHEMA_MESSAGES),
  lastName: z.string(LAST_NAME_SCHEMA_MESSAGES),
  street: z.string(STREET_ADDRESS_SCHEMA_MESSAGES),
  aptSuite: z.string().optional().nullable(),
  city: z.string(CITY_SCHEMA_MESSAGES),
  state: z.enum([states[0], ...states.slice(1)], {
    message: stateError,
    required_error: stateError
  }),
  zip: z
    .string(ZIP_CODE_SCHEMA_MESSAGES)
    .length(5, translate("invalid_zip_code"))
});
